// FsRevision — a single integer that bumps every time a write_file or
// edit_file tool call completes successfully. The Canvas component
// subscribes to this number and re-reads the preview file whenever it
// changes.
//
// Why a separate store rather than embedding this in transcript:
//   - transcript.messages mutates many times per second during streaming
//     (every text_delta). If Canvas listened to transcript directly it
//     would re-run its OPFS read effect ~30×/s. A dedicated revision
//     counter lets Canvas listen only to a value that changes when
//     disk has actually been touched.
//   - Decouples "what the model said" (transcript) from "what state
//     the file system is in" (this).
//
// The orchestrator bumps this on tool_result events where the tool name
// is write_file or edit_file. Reads (read_file / list_directory) do not
// change disk and do not bump.

import { create } from 'zustand';

interface FsRevisionStore {
  revision: number;
  bump: () => void;
}

export const useFsRevision = create<FsRevisionStore>((set, get) => ({
  revision: 0,
  bump: () => set({ revision: get().revision + 1 }),
}));
